import {ActionProps}                from '../types'
import {DisplayMessageActionConfig} from '../types/DisplayMessageActionConfig'
import React                        from 'react'
import {Space, Typography}                      from 'antd';

const DisplayMessageAction: React.FC<ActionProps<DisplayMessageActionConfig>> = ({config}) => {
  return (
    <Space direction="vertical" align="center">
      <Typography.Text>
        <span dangerouslySetInnerHTML={{__html: config.messageHtml}}/>
      </Typography.Text>
    </Space>
  )
}

export default DisplayMessageAction
